function initResizeListener() {
    var pardotForms = document.querySelectorAll(".blogPostMain .pardotForm");
    var parentContainers = document.querySelectorAll(".blogPostMain .richText--hasBgImage");

    if (pardotForms.length > 0 || parentContainers.length > 0) {
        const page = document.querySelector(".blogPostMain .page__content");

        const setPardotBg = function() {
            for (let i = 0; i < pardotForms.length; i++) {
                let pageContentLeft = page.getBoundingClientRect().left;
                pardotForms[i].style.left = `-${pageContentLeft}px`;
            }
        };

        const setImageBg = function() {
            for (let i = 0; i < parentContainers.length; i++) {
                let bgContainer = parentContainers[i].querySelector(".richText__bgImage");
                let bgContainerLeft = parentContainers[i].getBoundingClientRect().left;
                bgContainer.style.marginLeft = `-${bgContainerLeft}px`;
            }
        };

        setPardotBg();
        setImageBg();

        window.addEventListener("resize", function() {
            setPardotBg();
            setImageBg();
        });
    }
}

function init() {
    initResizeListener();
}

export default { init };
